import type { ThemeConfig } from '#imports'

export const useThemeConfig = () => {
  const appConfig = useAppConfig()
  const themeConfig = useState<ThemeConfig>('themeConfig', () => appConfig.theme as ThemeConfig)
  return { themeConfig }
}
